import React from 'react';
import { BlockContentContext } from '@components/block-content/BlockContent.utils';
import { PollSerializerProps } from './Poll.types';
import { PollBlock } from './PollBlock';
import { ArticleBlockContentGridCol } from '../ArticleBlockContentGridCol';

export const PollSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article) {
    return ({ value }: PollSerializerProps) => (
      <ArticleBlockContentGridCol>
        <PollBlock documentId={value._ref} />
      </ArticleBlockContentGridCol>
    );
  }
  return ({ value }: PollSerializerProps) => <PollBlock documentId={value._ref} />;
};
